export const FEC_IMPORT_POLLING_INTERVAL_MS = 3000

/**
 * The backend can still finish a detection it marked failed, but the longer it stays failed the less likely that is.
 * So the list is read often at first and then less and less, up to a ceiling, instead of every 3 seconds forever.
 */
export const FEC_IMPORT_FAILED_POLLING_STEPS = [
  { intervalMs: FEC_IMPORT_POLLING_INTERVAL_MS, untilMs: 60 * 1000 },
  { intervalMs: 10 * 1000, untilMs: 5 * 60 * 1000 },
] as const

export const FEC_IMPORT_FAILED_POLLING_MAX_INTERVAL_MS = 30 * 1000
